import { milesToMeters } from "../helper/functions";
import { useProviderSearchStore } from "../store/providerSearchStore";

import CustomMap from "./Map/CustomMap";
import CustomMarker from "./Map/CustomMarker";

export default function ProviderMapContainer() {
  const { mapDisplayData, loading, address, initAddress, showMap, setShowMap, maxDistance, selectedCenter } =
    useProviderSearchStore();
  const source = address ?? initAddress;
  const latitude = source?.additionalDetails.latitude ?? initAddress?.additionalDetails.latitude;
  const longitude = source?.additionalDetails.longitude ?? initAddress?.additionalDetails.longitude;

  return (
    <>
      {showMap && (
        <div className="flex-1 h-full w-full">
          <CustomMap
            data={mapDisplayData}
            loading={loading}
            radius={milesToMeters(maxDistance)}
            sourceLatitude={latitude}
            sourceLongitude={longitude}
            showMap={showMap}
            setShowMap={setShowMap}
            selectedCenter={selectedCenter}
            markerData={mapDisplayData}
          >
            <CustomMarker data={mapDisplayData} />
          </CustomMap>
        </div>
      )}
    </>
  );
}
